var blockquote_default = {
  "fontElementMap": "_9Y2VT",
  "quote": "_9BhPs"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
